/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceConfigurationModel } from '../../models/service-configuration-model';

export interface ServiceConfigurationIdGet$Params {
  id: string;
}

export function serviceConfigurationIdGet(http: HttpClient, rootUrl: string, params: ServiceConfigurationIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<ServiceConfigurationModel>> {
  const rb = new RequestBuilder(rootUrl, serviceConfigurationIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<ServiceConfigurationModel>;
    })
  );
}

serviceConfigurationIdGet.PATH = '/ServiceConfiguration/{id}';
